module.exports = __webpack_public_path__ + "static/media/home_landing_splash.3ab51769.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_landing_splash.png
// module id = 2812
// module chunks = 0